import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { HttpService } from 'src/app/services/http.service';
import { environment } from 'src/environments/environment';
import{ FILTERS_TYPES, createQuery } from 'src/app/utils/filter';
import { FormBuilder } from '@angular/forms';
import { ENTITY_TYPES, ABUSE_REPORT_STATUS, ENTITY_TYPES_ENUM } from 'src/app/utils/constants';

const fieldTypeMapper: any = {
  'userName': FILTERS_TYPES.TEXT,
  'userEmail': FILTERS_TYPES.TEXT,
  'entityType': FILTERS_TYPES.TEXT,
  'status': FILTERS_TYPES.TEXT,
  'createdOn': FILTERS_TYPES.DATE,
}

@Component({
  selector: 'app-abuse-reports',
  templateUrl: './abuse-reports.component.html',
  styleUrls: ['./abuse-reports.component.scss']
})
export class AbuseReportsComponent implements OnInit {

  @ViewChild('itemsTable') public dataTable: Table | undefined;

  entityTypes = ENTITY_TYPES;
  reportStatus = ABUSE_REPORT_STATUS;
  statuses = Object.keys(ABUSE_REPORT_STATUS).map((key: string) => ({label: ABUSE_REPORT_STATUS[key], value: key}),);
  entityTypesOptions = Object.keys(ENTITY_TYPES).map((key: string) => ({label: ENTITY_TYPES[key], value: key}),)

  data = [];
  fa = [
    {
      "createdOn": "2021-07-03T19:46:49.955Z",
      "entityId": "221ssidfshnsd-sdfjsdf",
      "entityType": "ACTIVITY_INFO",
      "id": "221ssidfshnsd-sdfjsdf",
      "message": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy",
      "phoneNumber": "809-923-9282",
      "status": "APPROVED",
      "updatedOn": "2021-07-03T19:46:49.955Z",
      "userEmail": "test@gmail.com",
      "userId": "221ssidfshnsd-sdfjsdf",
      "userImageProfile": "https://lh5.googleusercontent.com/-m503FHI5IEo/AAAAAAAAAAI/AAAAAAAAAAA/AMZuucnWfVeCmTnWiiQNkvsGtI1R5GoB3A/s96-c/photo.jpg",
      "userName": "Jhon Doe",
    },
    {
      "createdOn": "2021-07-03T19:46:49.955Z",
      "entityId": "221ssidfshnsd-sdfjsdf",
      "entityType": "ACTIVITY_INFO",
      "id": "221ssidfshnsd-sdfjsdf",
      "message": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy",
      "phoneNumber": "809-923-9282",
      "status": "APPROVED",
      "updatedOn": "2021-07-03T19:46:49.955Z",
      "userEmail": "test@gmail.com",
      "userId": "221ssidfshnsd-sdfjsdf",
      "userImageProfile": "https://lh5.googleusercontent.com/-m503FHI5IEo/AAAAAAAAAAI/AAAAAAAAAAA/AMZuucnWfVeCmTnWiiQNkvsGtI1R5GoB3A/s96-c/photo.jpg",
      "userName": "Jhon Doe",
    },
    {
      "createdOn": "2021-07-03T19:46:49.955Z",
      "entityId": "221ssidfshnsd-sdfjsdf",
      "entityType": "ACTIVITY_INFO",
      "id": "221ssidfshnsd-sdfjsdf",
      "message": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy",
      "phoneNumber": "809-923-9282",
      "status": "APPROVED",
      "updatedOn": "2021-07-03T19:46:49.955Z",
      "userEmail": "test@gmail.com",
      "userId": "221ssidfshnsd-sdfjsdf",
      "userImageProfile": "https://lh5.googleusercontent.com/-m503FHI5IEo/AAAAAAAAAAI/AAAAAAAAAAA/AMZuucnWfVeCmTnWiiQNkvsGtI1R5GoB3A/s96-c/photo.jpg",
      "userName": "Jhon Doe",
    },
    {
      "createdOn": "2021-07-03T19:46:49.955Z",
      "entityId": "221ssidfshnsd-sdfjsdf",
      "entityType": "ACTIVITY_INFO",
      "id": "221ssidfshnsd-sdfjsdf",
      "message": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy",
      "phoneNumber": "809-923-9282",
      "status": "APPROVED",
      "updatedOn": "2021-07-03T19:46:49.955Z",
      "userEmail": "test@gmail.com",
      "userId": "221ssidfshnsd-sdfjsdf",
      "userImageProfile": "https://lh5.googleusercontent.com/-m503FHI5IEo/AAAAAAAAAAI/AAAAAAAAAAA/AMZuucnWfVeCmTnWiiQNkvsGtI1R5GoB3A/s96-c/photo.jpg",
      "userName": "Jhon Doe",
    },
    {
      "createdOn": "2021-07-03T19:46:49.955Z",
      "entityId": "221ssidfshnsd-sdfjsdf",
      "entityType": "ACTIVITY_INFO",
      "id": "221ssidfshnsd-sdfjsdf",
      "message": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy",
      "phoneNumber": "809-923-9282",
      "status": "APPROVED",
      "updatedOn": "2021-07-03T19:46:49.955Z",
      "userEmail": "test@gmail.com",
      "userId": "221ssidfshnsd-sdfjsdf",
      "userImageProfile": "https://lh5.googleusercontent.com/-m503FHI5IEo/AAAAAAAAAAI/AAAAAAAAAAA/AMZuucnWfVeCmTnWiiQNkvsGtI1R5GoB3A/s96-c/photo.jpg",
      "userName": "Jhon Doe",
    },
    {
      "createdOn": "2021-07-03T19:46:49.955Z",
      "entityId": "221ssidfshnsd-sdfjsdf",
      "entityType": "ACTIVITY_INFO",
      "id": "221ssidfshnsd-sdfjsdf",
      "message": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy",
      "phoneNumber": "809-923-9282",
      "status": "APPROVED",
      "updatedOn": "2021-07-03T19:46:49.955Z",
      "userEmail": "test@gmail.com",
      "userId": "221ssidfshnsd-sdfjsdf",
      "userImageProfile": "https://lh5.googleusercontent.com/-m503FHI5IEo/AAAAAAAAAAI/AAAAAAAAAAA/AMZuucnWfVeCmTnWiiQNkvsGtI1R5GoB3A/s96-c/photo.jpg",
      "userName": "Jhon Doe",
    },
    {
      "createdOn": "2021-07-03T19:46:49.955Z",
      "entityId": "221ssidfshnsd-sdfjsdf",
      "entityType": "ACTIVITY_INFO",
      "id": "221ssidfshnsd-sdfjsdf",
      "message": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy",
      "phoneNumber": "809-923-9282",
      "status": "APPROVED",
      "updatedOn": "2021-07-03T19:46:49.955Z",
      "userEmail": "test@gmail.com",
      "userId": "221ssidfshnsd-sdfjsdf",
      "userImageProfile": "https://lh5.googleusercontent.com/-m503FHI5IEo/AAAAAAAAAAI/AAAAAAAAAAA/AMZuucnWfVeCmTnWiiQNkvsGtI1R5GoB3A/s96-c/photo.jpg",
      "userName": "Jhon Doe",
    },
    {
      "createdOn": "2021-07-03T19:46:49.955Z",
      "entityId": "221ssidfshnsd-sdfjsdf",
      "entityType": "ACTIVITY_INFO",
      "id": "221ssidfshnsd-sdfjsdf",
      "message": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy",
      "phoneNumber": "809-923-9282",
      "status": "APPROVED",
      "updatedOn": "2021-07-03T19:46:49.955Z",
      "userEmail": "test@gmail.com",
      "userId": "221ssidfshnsd-sdfjsdf",
      "userImageProfile": "https://lh5.googleusercontent.com/-m503FHI5IEo/AAAAAAAAAAI/AAAAAAAAAAA/AMZuucnWfVeCmTnWiiQNkvsGtI1R5GoB3A/s96-c/photo.jpg",
      "userName": "Jhon Doe",
    },
    {
      "createdOn": "2021-07-03T19:46:49.955Z",
      "entityId": "221ssidfshnsd-sdfjsdf",
      "entityType": "ACTIVITY_INFO",
      "id": "221ssidfshnsd-sdfjsdf",
      "message": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy",
      "phoneNumber": "809-923-9282",
      "status": "APPROVED",
      "updatedOn": "2021-07-03T19:46:49.955Z",
      "userEmail": "test@gmail.com",
      "userId": "221ssidfshnsd-sdfjsdf",
      "userImageProfile": "https://lh5.googleusercontent.com/-m503FHI5IEo/AAAAAAAAAAI/AAAAAAAAAAA/AMZuucnWfVeCmTnWiiQNkvsGtI1R5GoB3A/s96-c/photo.jpg",
      "userName": "Jhon Doe",
    },
    {
      "createdOn": "2021-07-03T19:46:49.955Z",
      "entityId": "221ssidfshnsd-sdfjsdf",
      "entityType": "ACTIVITY_INFO",
      "id": "221ssidfshnsd-sdfjsdf",
      "message": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy",
      "phoneNumber": "809-923-9282",
      "status": "APPROVED",
      "updatedOn": "2021-07-03T19:46:49.955Z",
      "userEmail": "test@gmail.com",
      "userId": "221ssidfshnsd-sdfjsdf",
      "userImageProfile": "https://lh5.googleusercontent.com/-m503FHI5IEo/AAAAAAAAAAI/AAAAAAAAAAA/AMZuucnWfVeCmTnWiiQNkvsGtI1R5GoB3A/s96-c/photo.jpg",
      "userName": "Jhon Doe",
    },
    {
      "createdOn": "2021-07-03T19:46:49.955Z",
      "entityId": "221ssidfshnsd-sdfjsdf",
      "entityType": "ACTIVITY_INFO",
      "id": "221ssidfshnsd-sdfjsdf",
      "message": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy",
      "phoneNumber": "809-923-9282",
      "status": "APPROVED",
      "updatedOn": "2021-07-03T19:46:49.955Z",
      "userEmail": "test@gmail.com",
      "userId": "221ssidfshnsd-sdfjsdf",
      "userImageProfile": "https://lh5.googleusercontent.com/-m503FHI5IEo/AAAAAAAAAAI/AAAAAAAAAAA/AMZuucnWfVeCmTnWiiQNkvsGtI1R5GoB3A/s96-c/photo.jpg",
      "userName": "Jhon Doe",
    },
    {
      "createdOn": "2021-07-03T19:46:49.955Z",
      "entityId": "221ssidfshnsd-sdfjsdf",
      "entityType": "ACTIVITY_INFO",
      "id": "221ssidfshnsd-sdfjsdf",
      "message": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy",
      "phoneNumber": "809-923-9282",
      "status": "APPROVED",
      "updatedOn": "2021-07-03T19:46:49.955Z",
      "userEmail": "test@gmail.com",
      "userId": "221ssidfshnsd-sdfjsdf",
      "userImageProfile": "https://lh5.googleusercontent.com/-m503FHI5IEo/AAAAAAAAAAI/AAAAAAAAAAA/AMZuucnWfVeCmTnWiiQNkvsGtI1R5GoB3A/s96-c/photo.jpg",
      "userName": "Jhon Doe",
    },
    {
      "createdOn": "2021-07-03T19:46:49.955Z",
      "entityId": "221ssidfshnsd-sdfjsdf",
      "entityType": "ACTIVITY_INFO",
      "id": "221ssidfshnsd-sdfjsdf",
      "message": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy",
      "phoneNumber": "809-923-9282",
      "status": "APPROVED",
      "updatedOn": "2021-07-03T19:46:49.955Z",
      "userEmail": "test@gmail.com",
      "userId": "221ssidfshnsd-sdfjsdf",
      "userImageProfile": "https://lh5.googleusercontent.com/-m503FHI5IEo/AAAAAAAAAAI/AAAAAAAAAAA/AMZuucnWfVeCmTnWiiQNkvsGtI1R5GoB3A/s96-c/photo.jpg",
      "userName": "Jhon Doe",
    },
  ];

  private readonly apiUrl = environment.apiUrl;
  private readonly appUrl = environment.appUrl;

  form: any;
  isLoadingForm: boolean = false;
  isDialogOpen: boolean = false;
  isEditMode: boolean = false;

  isLoading: boolean = false;
  pageIndex: number = 0;
  pageSize: number = 15;
  firstInPage: number = 0;
  totalRecords: number = 200;
  lastQuery: string = "";
  selectedItem: any;

  constructor(
    private fb: FormBuilder,
    private httpService: HttpService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) { }

  cols = [
    { field: 'name', header: 'Name' },
    { field: 'email', header: 'Email' },
    { field: 'entityType', header: 'Entity' },
    { field: 'createdOn', header: 'Create On' },
    { field: 'status', header: 'Status' },
  ];

  ngOnInit() {
    this.form = this.fb.group({
      userId: [""],
      userEmail: [""],
      userName: [""],
      userImageProfile: [""],
      phoneNumber: [""],
      id: [""],
      entityType: [""],
      entityId: [""],
      status: [""],
      message: [""],
      comments: [""],
      updatedOn: [null],
      createdOn: [null],
    });
   }

   private setForm(item: any) {
     this.selectedItem = item;

    this.form.patchValue({ userId: item.userId });
    this.form.patchValue({ userEmail: item.userEmail });
    this.form.patchValue({ userName: item.userName });
    this.form.patchValue({ userImageProfile: item.userImageProfile });
    this.form.patchValue({ phoneNumber: item.phoneNumber });

    this.form.patchValue({ id: item.id });
    this.form.patchValue({ entityType: item.entityType });
    this.form.patchValue({ entityId: item.entityId });
    this.form.patchValue({ status: item.status});
    this.form.patchValue({ message: item.message });
    this.form.patchValue({ comments: item.comments });

    this.form.patchValue({ createdOn: item.createdOn ? new Date(item.createdOn) : null });
    this.form.patchValue({ updatedOn: item.updatedOn ? new Date(item.updatedOn) : null });
    this.form.markAsPristine();
  }

   hasFormErrors() {
     return !this.form.valid;
   }

   fieldErrors(field: string) {
     const controlState = this.form.controls[field];
     return (controlState.dirty && controlState.errors) ? controlState.errors : null;
   }


  loadData(event: LazyLoadEvent) {  
    this.isLoading = true;
    this.firstInPage = event.first || 0;
    this.pageSize = event.rows || 0;
    this.pageIndex = this.pageSize > 0 ? Math.floor(this.firstInPage / this.pageSize) : 0;
    const querySearch: string = createQuery(event, fieldTypeMapper);
    const URL = `${this.apiUrl}/admin-center/abuse/v1/search?${querySearch}page=${this.pageIndex}&size=${this.pageSize}`;
    this.lastQuery = URL;
    this.search(URL);
  }

  async search(url: string) {
    const el = document.getElementsByClassName('page-container')[0];
    if(el) {
      el.scrollTop = 0;
    }

    try {
      const response = await this.httpService.doGet(url).toPromise();
      if (response) {
        this.data = response.content;
        this.totalRecords = response.totalElements;
      } else {
        this.data = [];
        this.totalRecords = 0;
        this.firstInPage = 0;
        this.pageIndex = 0;
      }
      this.isLoading = false;
    } catch(error: any) {
      this.data = [];
      this.totalRecords = 0;
      this.firstInPage = 0;
      this.pageIndex = 0;
      this.isLoading = false;
      console.log('Error: ', error);
      this.messageService.add({severity:'error', summary: 'Error', detail: error.message});
    }
  }

  refreshTable() {
    this.search(this.lastQuery);
  }

  clear(table: Table) {
    table.clear();
  }

  openNew() {
    this.form.reset();
    this.isEditMode = true;
    this.isDialogOpen = true;
  }

  viewItem(item: any) {
    this.form.reset();
    this.setForm(item);
    this.form.disable();
    this.isEditMode = false;
    this.isDialogOpen = true;
  }

  editItem(item: any) {
    this.form.reset();
    this.setForm(item);
    this.form.disable();
    this.form.get('status').enable();
    this.form.get('comments').enable();
    this.isEditMode = true;
    this.isDialogOpen = true;
  }

  tryToSaveItem() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to save the changes?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.saveItem();
        }
    });
  }

  async saveItem() {
    this.isLoadingForm = true;
    const URL = `${this.apiUrl}/admin-center/abuse/v1`;

    try {
      await this.httpService.doPut(URL, {
        id: this.form.get('id').value,
        status: this.form.get('status').value,
        comments: this.form.get('comments').value,
      }).toPromise();
      this.messageService.add({
        severity:'success',
        summary: 'Successful',
        detail: 'Report abuse changes saved',
        life: 3000
      });
      this.isLoadingForm = false;
      this.hideDialog();
      this.refreshTable();
    } catch(error: any) {

      this.isLoadingForm = false;
      console.log('Error: ', error);
      this.messageService.add({severity:'error', summary: 'Error', detail: error.message});
    }
  }

  hideDialog() {
    this.isDialogOpen = false;
    this.isEditMode = false;
  }

  getEntityUrl(item: any): string {
    switch(item.entityType) {
      case ENTITY_TYPES_ENUM.HUB:
        return `${this.appUrl}/~hub/client-view?hubId=${item.entityId}`;
      case ENTITY_TYPES_ENUM.ACTIVITY_INFO:
        return `${this.appUrl}/~hub/actinfo/client-view?activityId=${item.entityId}`;
      case ENTITY_TYPES_ENUM.ACTIVITY_REQUEST:
        return `${this.appUrl}/~hub/actrqt/client-view?activityId=${item.entityId}`;
      case ENTITY_TYPES_ENUM.ACTIVITY_RESERVATION:
        return `${this.appUrl}/~hub/actrvt/client-view?activityId=${item.entityId}`;
      case ENTITY_TYPES_ENUM.ACTIVITY_PRODUCT_LISTING:
        return `${this.appUrl}/~hub/actpl/client-view?activityId=${item.entityId}`;
      case ENTITY_TYPES_ENUM.ACTIVITY_MENU:
        return `${this.appUrl}/~hub/actmenu/client-view?activityId=${item.entityId}`;
      case ENTITY_TYPES_ENUM.CATEGORY:
        return `${this.appUrl}/~hub/category/client-view?categoryId=${item.entityId}`;
      case ENTITY_TYPES_ENUM.REVIEW:
        const reviewData = JSON.parse(item.entityId);
        const url = this.getEntityUrl({
          entityType: reviewData.entityType,
          entityId: reviewData.entityId
        });
        return `${url}&userId=${reviewData.userId}&entityType=${reviewData.entityType}#showReview`;
    }
    return "";
  }

}
